import { makeStyles } from '@bamboohr/fabric';

export default makeStyles(() => {
	return {
		view: {
			textAlign: 'center',
		},
	};
});
